import React, { FunctionComponent, memo } from 'react'

import { Global, css, GlobalProps } from '@emotion/react'
import emotionReset from 'emotion-reset'

const reset = css`
  ${emotionReset}

  *,
  *::after,
  *::before {
    box-sizing: border-box;
    -moz-osx-font-smoothing: grayscale;
    -webkit-font-smoothing: antialiased;
    font-smoothing: antialiased;
  }

  @media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {
    svg {
      overflow: hidden;
    }
  }
`

export const GlobalStyles: FunctionComponent<{
  styles: GlobalProps['styles']
}> = memo(({ styles }) => <Global {...{ styles }} />)

export const GlobalStylesReset = memo(() => (
  <GlobalStyles {...{ styles: reset }} />
))
